import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(10)} rgba(0, 0, 0, 0.2);
  padding: ${pxToRem(30)};
  height: ${pxToRem(271)};
  width: ${pxToRem(429)};
  border-bottom: ${pxToRem(1)} solid rgb(225, 224, 229);
  border-radius: ${pxToRem(16)};
  background: rgb(255, 255, 255);

  p {
    text-align: center;
    margin-top: ${pxToRem(30)};
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 500;
  }
`;

export const ModalIcon = styled.svg`
  margin-bottom: ${pxToRem(30)};
`;

export const CloseButton = styled.button`
  position: relative;
  top: ${pxToRem(20)};
  left: ${pxToRem(180)};
  background: none;
  border: none;
  font-size: ${pxToRem(18)};
  cursor: pointer;
  color: #333;
  padding: 0;

  &:hover {
    color: #000;
  }
`;
